import React from 'react';
import { navigate } from 'gatsby';
import { FormattedMessage, useIntl } from 'react-intl';

import AlternativeUploadForm from './AlternativeUploadForm';
import { messages } from '../../translations/general';
import Breadcrumb from '../../../Breadcrumb';
import Head from '../../../PrivateHead';
import { useSanitizedOrder } from '../hooks/useOrders';

interface AlternativeUploadPageProps {
  orderId: string;
  lineItemId: string;
}

const AlternativeUploadPage = ({ orderId, lineItemId }: AlternativeUploadPageProps) => {
  const intl = useIntl();
  const { order } = useSanitizedOrder(orderId, intl.locale, 'order_detail_api_failure');
  const orderNumber = order?.orderNumber;
  const currentLineItem = order?.lineItems.filter(
    (lineItem) => lineItem.id === lineItemId,
  )[0];
  const editorType = currentLineItem?.custom.fields.editorType || 'alternative-upload';
  return (
    <>
      <Head title={intl.formatMessage(messages.alternativeUpload)} />
      <Breadcrumb>
        <Breadcrumb.Item to="../../../..">
          <FormattedMessage id="account.index.title" defaultMessage="My account" />
        </Breadcrumb.Item>
        <Breadcrumb.Item to="../../..">
          <FormattedMessage id="account.orders.title" defaultMessage="Order title" />
        </Breadcrumb.Item>
        <Breadcrumb.Item to="../..">
          <FormattedMessage id="account.orders.detail.title" defaultMessage="Order" /> {orderNumber}
        </Breadcrumb.Item>
        <Breadcrumb.Item isCurrentPage>
          <FormattedMessage id="account.lineItem.alternativeUpload.title" defaultMessage="Alternative upload title" />
        </Breadcrumb.Item>
      </Breadcrumb>

      <AlternativeUploadForm editorType={editorType} orderId={orderId} lineItemId={lineItemId} onSubmit={() => navigate('../..')} />
    </>
  );
};

export default AlternativeUploadPage;
